import React from 'react'
import ChBoxSelect from 'bstrap-react-mobx-admin/new_src/input/chbox_multiselect'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../../input/date'
import EmbededEntityInput from '../../input/embedded_entity'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import moment from 'moment'

const ExpenseForm = ({ store, state, record, updateFormField, errors }) => {
  const { stageTwoRestricted } = store.timeRestriction.checkSubentity(store, state)
  const minDate = store.options.get('timeRestrictions') && store.options.get('timeRestrictions')[0] && store.options.get('timeRestrictions').reverse()[0].date
    ? moment(store.options.get('timeRestrictions').reverse()[0].date).add(1, 'days')
    : moment()
  record.get('limit') && record.set('limit', parseFloat(record.get('limit')).toFixed(2))
  return (
    <div className='row'>
      <fieldset disabled={stageTwoRestricted}>
        <div className='col-xs-12'>
          {!record.get('platform')
            ? <ChBoxSelect label={store.__('platform')} attr={'platform'} record={record}
              onChange={updateFormField} optionsrecord={store.options} store={store}
              optionsattr={'Platforms'} labelattr='text' errors={errors}
              options={store.options.get('Platforms')} />
            : <SelectInput label={store.__('platform')} attr={'platform'} record={record}
              onChange={updateFormField} optionsrecord={store.options}
              optionsattr={'Platforms'} labelattr='text' errors={errors} />}
          <SelectInput label={store.__('right type')} attr={'right_type'} record={record}
            onChange={updateFormField} labelattr='text' valueattr='value'
            optionsrecord={store.options} optionsattr={'RightsTypes'} errors={errors}
          />
          <SelectInput label={store.__('type')} attr={'expense_type'} record={record}
            onChange={updateFormField} optionsrecord={store.options}
            optionsattr={'ExpenseTypes'} labelattr='text' errors={errors} />
          <TextInput type='number' min='1' label={store.__('limit')}
            attr={'limit'} record={record}
            onChange={updateFormField} errors={errors} />
          <DateInput label={store.__('due date')} disabled={stageTwoRestricted} minDate={minDate}
            attr={'due_date'} record={record} onChange={updateFormField} errors={errors} />
          <DateInput label={store.__('expire date')} disabled={stageTwoRestricted} minDate={minDate}
            attr={'expire_date'} record={record} onChange={updateFormField} errors={errors} />
        </div>
      </fieldset>
    </div>
  )
}

const ExpensesEdit = ({ store, items, ...rest }) => {
  return (
    <EmbededEntityInput {...rest}
      store={store}
      items={items}
      edit_title={store.__('edit costs')}
      add_title={store.__('add costs')}
      onAddRow={(rec) => {
        rec.platform && rec.platform.split(',').map(i => {
          i && items.push(Object.assign(rec, { platform: i }))
        })
      }}
      fields={[
        (attr, row) => (
          <OptionsField attr={attr} val={row[attr]}
            options={store.options.get('Platforms')}
            labelattr='text' />
        ),
        (attr, row) => (
          <OptionsField attr={attr} val={row[attr]}
            options={store.options.get('RightsTypes')}
            labelattr='text'
            valueattr='value' />
        ),
        (attr, row) => (
          <OptionsField attr={attr} val={row[attr]}
            options={store.options.get('ExpenseTypes')}
            labelattr='text' />
        ),
        (attr, row) => (<TextField attr={attr} val={row[attr]} toFixed={2} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} />)
      ]}
      rowId={(row) => (row.platform)}
      EditForm={ExpenseForm}
    />
  )
}
export default ExpensesEdit
